import type { Lang } from '../../lib/i18n';
import { timerStrings } from '../../lib/tools';
import { ToolLanding } from '../../components/tools/ToolLanding';
import { HoldTimer, TIMER_SLUG, TimerSafety } from '../../components/tools/HoldTimer';

export default function HoldTimerPage({ lang = 'en' as Lang }: { lang?: Lang }) {
  const t = timerStrings(lang);
  return (
    <ToolLanding
      lang={lang}
      slug={TIMER_SLUG}
      copy={t}
      embedHeight={1100}
      tool={<HoldTimer lang={lang} />}
      extra={<TimerSafety lang={lang} />}
      example={
        <section className="mb-14" aria-labelledby="example-heading">
          <h2 id="example-heading" className="text-2xl md:text-3xl font-extrabold text-ink mb-2">{t.example.heading}</h2>
          <p className="text-muted mb-4">{t.example.intro}</p>
          <ol className="card-float p-5 space-y-2 list-decimal pl-10 text-ink">
            {t.example.steps.map((s, i) => <li key={i}>{s}</li>)}
          </ol>
        </section>
      }
    />
  );
}
